import React, { PropsWithChildren } from 'react';

import styles from './ghost-button.scss';

interface GhostButtonProps {
  isSelected?: boolean;
  isUnavailable?: boolean;
  onClick?: () => void;
}

function GhostButton(props: PropsWithChildren<GhostButtonProps>) {
  const { children, isSelected, isUnavailable, onClick } = props;
  let className = 'btn';

  if (isSelected) {
    className = 'btn-selected';
  } else if (isUnavailable) {
    className = 'btn-unavailable';
  }

  return (
    <button className={styles[className]} onClick={onClick} type="button">
      {children}
    </button>
  );
}

export default GhostButton;
